import { makeStyles } from "@mui/styles";

import { media } from "src/utils/media";
import theme from "src/theme";
import { appColors, backgroundColors } from "src/consts/app-config";
import { windowsSizeParams } from "src/consts/window-size-params";

export const useStyles = makeStyles({
    mobileUserSettingsWrapper: {
        width: "calc(100dvw - 30px)",
        height: `calc(100dvh - ${windowsSizeParams.mobileAppBarHeight}px)`,
        maxWidth: "550px",
        maxHeight: "800px",
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
        overflow: "scroll",
        "-ms-overflow-style": "none",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
            width: "0!important",
        },
        padding: "15px 0px",
        gridGap: "20px",
        [theme.breakpoints.up("sm")]: {
            height: `calc(100dvh - ${windowsSizeParams.largeTabletAppBarHeight}px)`,
        },
    },

    mobileUserSettingsTabPanel: {
        "&.MuiTabPanel-root": {
            [theme.breakpoints.up("xs")]: { padding: "5px 0px 3px" },
        },
    },

    tabs: {
        width: "100%",
        minHeight: "35px !important",
        "& .MuiTabs-indicator": {
            background: appColors.white,
        },
        "& .MuiTabs-scroller": {
            width: "100%",
        },
        "& .MuiTabs-flexContainer": {
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
        },
    },
    tab: {
        display: "flex!important",
        alignItems: "center!important",
        padding: "0!important",
        minWidth: "0px!important",
        minHeight: "0px!important",
        color: appColors.txt400 + "!important",
        fontSize: "16px!important",
        // @ts-ignore
        fontWeight: "500!important",
        // @ts-ignore
        textTransform: "none!important",
        "&.Mui-selected": {
            color: appColors.white + "!important",
            fontWeight: "700!important",
        },
    },
});
